"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorialListReferenceSchema = void 0;
exports.EditorialListReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/editorial-lists.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "EditorialListReference",
    "description": "An editorial collection content resources for a given topic",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:editorial-lists"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWRpdG9yaWFsLWxpc3RzLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3JlZmVyZW5jZS9jb250ZW50L2VkaXRvcmlhbC1saXN0cy5zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSw0QkFBNEIsR0FBRztJQUMxQyxLQUFLLEVBQUUsK0VBQStFO0lBQ3RGLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLHdCQUF3QjtJQUNqQyxhQUFhLEVBQUUsNkRBQTZEO0lBQzVFLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixJQUFJO0tBQ0w7SUFDRCxZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUU7Z0JBQ04sNEJBQTRCO2FBQzdCO1lBQ0QsTUFBTSxFQUFFLFFBQVE7U0FDakI7UUFDRCxJQUFJLEVBQUU7WUFDSixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsNkVBQTZFO1NBQ3pGO0tBQ0Y7Q0FDRixDQUFBIn0=